import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { useStock } from '../context/StockContext';
const features = ['Gorra Misery Premium Black (Serie 001-100)', 'Caja Luxury de exhibición', 'Certificado de autenticidad numerado', 'Pack de Stickers exclusivos "Misery Club"'];
export function ValueStack() {
  const {
    recordPurchase
  } = useStock();
  const handleBuy = () => {
    recordPurchase();
  };
  return <section id="precio" className="bg-black py-12 md:py-20 px-4" data-id="element-97">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="max-w-4xl mx-auto" data-id="element-98">
        <h2 className="font-bebas text-5xl md:text-6xl text-white text-center mb-12 tracking-wider" data-id="element-99">
          MÁS QUE UNA GORRA,
          <br data-id="element-100" />
          ES UNA PIEZA DE COLECCIÓN.
        </h2>

        <div className="bg-[#0A0A0A] border-2 border-misery-purple p-8 md:p-12 space-y-6" data-id="element-101">
          <div className="space-y-4" data-id="element-102">
            {features.map((feature, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1,
            duration: 0.5
          }} className="flex items-start gap-3" data-id="element-103">
                <Check className="w-6 h-6 text-misery-magenta flex-shrink-0 mt-1" data-id="element-104" />
                <span className="font-inter text-white text-lg" data-id="element-105">{feature}</span>
              </motion.div>)}
          </div>

          <div className="border-t border-gray-800 pt-8 mt-8" data-id="element-106">
            <div className="flex items-center justify-center" data-id="element-107">
              <span className="font-bebas text-5xl md:text-6xl text-misery-magenta" data-id="element-108">
                $1,390.84
              </span>
            </div>
          </div>

          <a href="https://www.misery.lat/cart/52836345020715:1" target="_blank" rel="noopener noreferrer" onClick={handleBuy} className="block w-full bg-misery-purple hover:bg-misery-magenta transition-all duration-300 text-white font-bebas text-3xl py-6 tracking-wider transform hover:scale-105 mt-6 text-center" data-id="element-109">
            ASEGURAR MI EDICIÓN LIMITADA
          </a>
        </div>
      </motion.div>
    </section>;
}